module.exports = __webpack_public_path__ + "media/images/facebook@2x-098f942d6641068399c878d75fb0a16a.png";